
import {Component} from 'vue-property-decorator';
import LastSync from '@/components/LastSync.vue';
import BaseReport from '../../../BaseReport.vue';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import DataEmpTargetDashboard from '@/components/reports-v3/components/codedWidgets/custom/dataemp/DataEmpTargetDashboard.vue';
import moment from 'moment';

@Component({
    components: {
        LastSync,
        StickyFilterContainer,
        DataEmpTargetDashboard,
    },
})
export default class DataEmpCustom2 extends BaseReport {
    public selectedYear: number = moment().year();
    public selectedDepartment: string = 'all';
    public yearOptions: number[] = [moment().year()];
    public departments: string[] = [];

    public onFilterOptions(options: { years: number[]; projects: string[] }) {
        if (options.years && options.years.length > 0) {
            this.yearOptions = options.years;
        }
        if (options.projects && options.projects.length > 0) {
            this.departments = options.projects;
        }
    }
}
